// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"300":"501785a0","350":"e202f7af","401":"c0f8d964","435":"23e52b07","470":"84300662","574":"0c3df432","639":"bbcaae79","642":"541317e7","723":"eb0f6d2b","787":"d5c6303f","936":"53952ee1"}[chunkId] + ".chunk.js";
};